import React from "react";

interface PaginateProps {
  pageCount?: number;
  pageNumber: number;
  onPageChange: (page: number) => void;
  totalPages: number;
  pageSize?: number;
  totalRecords: number;
  label?: string;
}

const Pagination: React.FC<PaginateProps> = ({
  pageNumber,
  onPageChange,
  totalPages,
  pageSize = 10,
  totalRecords,
  label,
}) => {
  if (totalRecords <= pageSize) return null;

  const startRecord = totalRecords === 0 ? 0 : (pageNumber - 1) * pageSize + 1;

  const endRecord = Math.min(pageNumber * pageSize, totalRecords);

  return (
    <div className="widget-footer">
      <span className="footer-count">
        Showing {startRecord}-{endRecord} of {totalRecords} {label}
      </span>

      <div className="pagination">
        <button
          type="button"
          className={`page-btn ${pageNumber === 1 ? "muted" : ""}`}
          disabled={pageNumber === 1}
          onClick={() => onPageChange(pageNumber - 1)}
        >
          Previous
        </button>

        <button type="button" className="page-btn active">
          Page {pageNumber} of {totalPages}
        </button>

        <button
          type="button"
          className={`page-btn ${pageNumber === totalPages ? "muted" : ""}`}
          disabled={pageNumber === totalPages}
          onClick={() => onPageChange(pageNumber + 1)}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default Pagination;
